import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetLivestockQuery,
  usePublicGetLivestockQuery,
  useGetLivestockDefaultsQuery,
  usePublicGetLivestockDefaultsQuery,
  useUpdateLivestockMutation
} from '../features/modules/livestockApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting livestock data based on the current route.
 */
export const useContextAwareGetLivestock = createContextAwareHook(
  useGetLivestockQuery,
  usePublicGetLivestockQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting livestock defaults based on the current route.
 */
export const useContextAwareGetLivestockDefaults = createContextAwareHook(
  useGetLivestockDefaultsQuery,
  usePublicGetLivestockDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateLivestockMutation
}; 